import {
  formatDate,
  formatReadingSource,
  formatScaleReadingValue,
  statusClass,
} from './kioskFormatters';
import {
  getReadingDeviceKind,
  getReadingDeviceType,
} from './kioskTransforms';

export function KioskReadingsList({
  readings,
  readingsState,
  deviceMap,
}) {
  if (readingsState.type === 'pending') {
    return (
      <div className="kiosk-loading-block" role="status" aria-live="polite">
        <div className="kiosk-loading-spinner" aria-hidden="true" />
        <p>{readingsState.message}</p>
      </div>
    );
  }

  if (readingsState.type === 'error') {
    return (
      <div className="kiosk-empty">
        <strong>Unable to load readings</strong>
        <p>{readingsState.message}</p>
      </div>
    );
  }

  if (readings.length === 0) {
    return (
      <div className="kiosk-empty">
        <strong>ยังไม่มีการอ่าน</strong>
        <p>เมื่อมีการส่งข้อมูลจากเครื่องสแกนและเครื่องชั่งสำหรับคำขอนี้ ข้อมูลจะปรากฏที่นี่โดยอัตโนมัติ</p>
      </div>
    );
  }

  const displayedReadings = readings.map((reading) => ({
    ...reading,
    displayValue: getReadingDeviceKind(reading, deviceMap) === 'Scale'
      ? formatScaleReadingValue(reading.readingValue)
      : reading.readingValue,
  }));

  const displayProductName = (reading) => {
    if (getReadingDeviceKind(reading, deviceMap) === 'Scanner') {
      return reading.productName || reading.storedProductName || reading.scannedProduct?.name || 'ไม่พบสินค้า';
    }
  };

  return (
    <div className="kiosk-reading-list">
      {displayedReadings.map((reading) => (
        <article key={reading.id} className="kiosk-attempt-card">
          <div className="kiosk-attempt-top">
            <div>
              <h3>{getReadingDeviceType(reading, deviceMap) || 'การอ่าน'}</h3>
              <p>
                {reading.deviceId}
                {formatReadingSource(reading.readingSource)
                  ? ` · ${formatReadingSource(reading.readingSource)}`
                  : ''}
              </p>
            </div>
            <span className={`kiosk-pill kiosk-pill-${statusClass(reading.readingStatus)}`}>
              {reading.readingStatus}
            </span>
          </div>

          <div className="kiosk-attempt-value">{reading.displayValue}</div>

          {reading.errorMessage ? (
            <p className="kiosk-reading-error" role="alert">{reading.errorMessage}</p>
          ) : null}
          
          {displayProductName(reading) && (
            <div style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', backgroundColor: '#eaf8ed', borderRadius: '0.5rem'}}>
              <p style={{padding: '10px'}}>{displayProductName(reading)}</p>
            </div>
          )}
         
          <dl className="kiosk-meta-grid">
            <div>
              <dt>เกิดขึ้นเมื่อ</dt>
              <dd>{formatDate(reading.occurredAtUtc)}</dd>
            </div>
            <div>
              <dt>รหัสการอ่าน</dt>o9
              <dd>{reading.id}</dd>
            </div>
          </dl>
        </article>
      ))}
    </div>
  );
}
